import * as bodyScrollLock from 'body-scroll-lock';

/**
 * Add loading state to button
 *
 * @param {object} elem
 */
export function buttonStartLoadingState(elem, replacement_text) {
    if (elem.hasClass('btn--has-loader')) {
        return;
    }

    if (replacement_text) {
        elem.attr('original-text', elem.text()).text(replacement_text);
    }

    elem.addClass('btn--has-loader').append(`<span class="btn__loader">${Slate.svgs.spinner}</span>`);

    window.dispatchEvent(new CustomEvent('slate/buttons/loadingStart', {
        detail: {
            element: elem,
            replacementText: replacement_text,
        },
    }));
}

/**
 * Remove loading state from button
 *
 * @param {object} elem
 */
export function buttonStopLoadingState(elem) {
    let original_text = elem.attr('original-text');

    elem.removeClass('btn--has-loader').find('.btn__loader').remove();

    if (original_text) {
        elem.text(original_text);
    }

    window.dispatchEvent(new CustomEvent('slate/buttons/loadingStop', {
        detail: {
            element: elem,
        },
    }));
}

/**
 * Toggle on/off loading state
 *
 * @param {object} wrapper
 */
export function toggleLoadingState(wrapper) {
    if (wrapper.hasClass('is-loading')) {
        wrapper.removeClass('is-loading').find('.is-loading__spinner').remove();
    } else {
        wrapper.addClass('is-loading').append(`<span class="is-loading__spinner">${Slate.svgs.spinner}</span>`);
    }

    window.dispatchEvent(new CustomEvent('slate/toggleLoadingState', {
        detail: {
            wrapper: wrapper,
        },
    }));
}

/**
 * Lock body scroll
 *
 * @param {HTMLElement} scrollable_element
 */
export function lockScroll(scrollable_element) {
    bodyScrollLock.disableBodyScroll(scrollable_element);

    window.dispatchEvent(new CustomEvent('slate/scroll/lock', {
        detail: {
            element: scrollable_element,
        },
    }));
}

/**
 * Clear body scroll lock
 */
export function unlockScroll() {
    bodyScrollLock.clearAllBodyScrollLocks();

    window.dispatchEvent(new CustomEvent('slate/scroll/unlock'));
}
